const UnderConstruction=()=>{
    return(<>
    <h2>The page is under construction</h2>
    </>)
}

export default  UnderConstruction;